import { paymentSlipBatchStrings } from '@data/paymentSlipBatch';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: `${paymentSlipBatchStrings.payment_slip_batch}一覧`,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 3,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
